var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeltaLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 26,
    viewBox: "0 0 158 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6083_12615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9965 22.526L15.959 15.7666V0.895996L29.9965 22.526ZM31.1126 25.104L15.959 18.7062V25.104H31.1126Z",
    fill: "#565A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92139 22.526L15.9589 0.895996V15.7666L1.92139 22.526Z",
    fill: "#565A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.805176 25.1044H15.9588V18.7065L0.805176 25.1044Z",
    fill: "#565A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3385 20.6709C32.8887 20.6709 33.3445 21.111 33.3445 21.6612C33.3445 22.2114 32.9044 22.6673 32.3542 22.6673C31.804 22.6673 31.3481 22.2271 31.3481 21.6769C31.3481 21.111 31.7883 20.6709 32.3385 20.6709ZM32.3385 22.5101C32.8101 22.5101 33.1873 22.1328 33.1873 21.6612C33.1873 21.1896 32.8101 20.8124 32.3385 20.8124C31.8669 20.8124 31.4896 21.1896 31.4896 21.6612C31.4896 22.1328 31.8669 22.5101 32.3385 22.5101ZM32.1184 22.2428H31.9769V21.0953H32.4171C32.6843 21.0953 32.7786 21.2054 32.7786 21.4097C32.7943 21.5826 32.6529 21.7241 32.4957 21.7398L32.8415 22.2428H32.6843L32.3385 21.7398H32.1341L32.1184 22.2428ZM32.1184 21.5983H32.307C32.4642 21.5983 32.6371 21.5826 32.6371 21.394C32.6371 21.2525 32.4957 21.2054 32.3856 21.2054H32.1341V21.5983H32.1184Z",
    fill: "#565A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9487 22.5261H49.7553C56.7662 22.5261 60.9318 18.8949 60.9318 12.8743C60.9318 6.85376 56.7662 3.23828 49.7553 3.23828H42.9487V22.5261ZM47.2559 6.58653H49.7553C54.2982 6.58653 56.5775 8.83442 56.5775 12.8743C56.5775 16.9142 54.2982 19.1621 49.7553 19.1621H47.2559V6.58653Z",
    fill: "#565A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5826 14.1633H83.7725V10.8151H75.5826V6.58653H84.8414V3.23828H71.2598V22.5261H85.1401V19.1778H75.5826V14.1633Z",
    fill: "#565A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.694 19.1778H101.378V3.23828H97.0552V22.5261H109.694V19.1778Z",
    fill: "#565A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.959 3.23828H115.651V6.58653H122.128V22.5261H126.466V6.58653H132.959V3.23828Z",
    fill: "#565A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 22.5261H153.488L151.602 17.7002H143.758L141.872 22.5261H137.659L145.723 3.15967H150.077L158 22.5261ZM150.376 14.462L147.688 7.60828L144.984 14.462H150.376Z",
    fill: "#565A6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6083_12615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.195,
    height: 24.208,
    fill: "white",
    transform: "translate(0.805176 0.895996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeltaLogo1);
export default __webpack_public_path__ + "static/media/Delta_logo 1.c3bbe7ec1ba3db8708683823ba2ac0da.svg";
export { ForwardRef as ReactComponent };